<template>
  <div class="intro-container">
    <router-link to="/cv">
      <div class="intro-container-inner">
        <div class="intro-title">
          Younggeol Cho
        </div>
        <div class="intro-subtitle">
          Developer, Researcher, Instructor, and Maker
<!--          I am a research officer at Agency for Defense Development(ADD) <br>-->
        </div>
        <div class="intro-footer attach-down">
          Click anywhere for more information
        </div>
      </div>
    </router-link>
  </div>
</template>

<script>
export default {
  name: 'Main',
  components: {},
  data() {
    return {
      tmHandler: undefined
    }
  },
  mounted() {
    this.tmHandler = setTimeout(() => {this.$router.push('/cv/')}, 5000);
  },
  destroyed() {
    clearTimeout(this.tmHandler)
  }
}
</script>

<style>
#app {
}

body {
  overflow: hidden;
}
</style>



// WEBPACK FOOTER //
// src/components/Main.vue